export const SCHEDULEREPORT_NOTSCHEDULED_OPTION_VALUE = 0
export const SCHEDULEREPORT_ONCE_OPTION_VALUE = 1
export const SCHEDULEREPORT_HOURLY_OPTION_VALUE = 12
export const SCHEDULEREPORT_DAILY_OPTION_VALUE = 20
export const SCHEDULEREPORT_WEEKLY_OPTION_VALUE = 21
export const SCHEDULEREPORT_MONTHLY_OPTION_VALUE = 22

export const SCHEDULEREPORT_FORMAT_TYPE_CSV = 0
export const SCHEDULEREPORT_FORMAT_TYPE_PDF = 10
export const SCHEDULEREPORT_FORMAT_TYPE_RTF = 11
export const SCHEDULEREPORT_FORMAT_TYPE_PNG = 12
export const SCHEDULEREPORT_FORMAT_TYPE_XLS = 13

export const DEFAULT_ALLOWED_CUSTOM_EMAILS: number = 10
